import { useTranslation } from '#/features/localization/utils';

import TabLabel from './TabLabel';

export default function TabLabelFundingPayments() {
  const { t } = useTranslation();

  return <TabLabel>{t('Funding Payments')}</TabLabel>;
}
